import clsx from 'clsx';

export function ChatTitleSkeleton({ className }: { className?: string }) {
  return (
    <span
      aria-label="Generating title"
      className={clsx(
        'block h-3 animate-pulse rounded-full bg-gray-200',
        className
      )}
      role="status"
    />
  );
}
